import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isSameMonth/index.js';

var require$$50 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$50 as default };
